import { TooltipDesktop } from '@cian/ui-kit';

import * as styles from './RgrCertificate.css';
import { RgrTooltip } from '../RgrTooltip';

export const RgrCertificate = () => {
  return (
    <TooltipDesktop title={<RgrTooltip />} theme="white" placement="right-start">
      <div className={styles['icon']} data-name="RgrCertificate" />
    </TooltipDesktop>
  );
};
